import React from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/Footer.css';
import CognoraLogo from '../../assets/svg/CognoraLogo.svg';
import { DarkModeIcon, Sun01Icon, SystemUpdate01Icon, NewTwitterIcon } from 'hugeicons-react';
import { GithubIcon, Linkedin01Icon } from 'hugeicons-react';
import { useWindow } from '../../contexts/WindowContext';

const Footer = () => {
  const { theme, toggleTheme } = useWindow();

  const renderThemeIcon = () => {
    switch(theme) {
      case 'light':
        return <Sun01Icon size={20} aria-hidden="true" />;
      case 'dark':
        return <DarkModeIcon size={20} aria-hidden="true" />;
      default:
        return <SystemUpdate01Icon size={20} aria-hidden="true" />;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-left">
            <Link to="/" className="logo-link">
              <img src={CognoraLogo} alt="Cognora Logo" className="footerlogo" />
            </Link>

            <div className="footer-left-bottom">
              <div className="social-links">
                <a
                  href="https://twitter.com/CognoraAI"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Follow us on Twitter"
                >
                  <NewTwitterIcon size={20} />
                </a>
                <a
                  href="https://github.com/Cognora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="View our GitHub"
                >
                  <GithubIcon size={20} />
                </a>
                <a
                  href="https://linkedin.com/company/cognoraai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Connect on LinkedIn"
                >
                  <Linkedin01Icon size={20} />
                </a>
                <button
                  onClick={toggleTheme}
                  className="theme-button social-link"
                  aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
                >
                  {renderThemeIcon()}
                </button>
              </div>
              <div className="footer-bottom-content">
                <p className="copyright">
                  &copy; {new Date().getFullYear()} Cognora. All rights reserved.
                </p>
              </div>
            </div>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h3 className="link-group-title">Plans</h3>
              <nav className="link-list">
                <Link to="/pricing" className="footer-link">Pricing</Link>
                <Link to="/student" className="footer-link">Student</Link>
              </nav>
            </div>

            <div className="link-group">
              <h3 className="link-group-title">Company</h3>
              <nav className="link-list">
                <Link to="/about" className="footer-link">About Us</Link>
                <Link to="/news" className="footer-link">News</Link>
                <Link to="/blog" className="footer-link">Blog</Link>
                <Link to="/careers" className="footer-link">Careers</Link>
              </nav>
            </div>

            <div className="link-group">
              <h3 className="link-group-title">Terms and Policies</h3>
              <nav className="link-list">
                <Link to="https://cognora.ca/privacy-policy" className="footer-link">Privacy Policy</Link>
                <Link to="https://cognora.ca/terms-of-service" className="footer-link">Terms of Service</Link>
                <Link to="/cookies" className="footer-link">Cookies</Link>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;